module.exports = __webpack_public_path__ + "img/c7244ee22a5ad56c46b26f8e7304b1ac.png";